import {
  Controller,
  Control,
  FieldValues,
  Path,
  FieldError,
} from "react-hook-form";
import Select, { Options } from "react-select";

import { Optional } from "../../enums/types";

export type Option = { value: string; label: string };

type SelectProps<T extends FieldValues> = {
  name: Path<T>;
  label: string;
  defaultValue: Optional<Option>;
  control: Control<T>;
  htmlFor: string;
  options: Options<Option>;
  isDisabled?: boolean;
  error?: FieldError;
};

export function SelectInputField<T extends FieldValues>({
  control,
  options,
  name,
  isDisabled,
  defaultValue,
  htmlFor,
  label,
  error,
}: SelectProps<T>) {
  return (
    <>
      <label
        htmlFor={htmlFor}
        className="block font-normal tmb-1 text-gray-500"
      >
        {label}
      </label>
      <Controller
        name={name}
        control={control}
        defaultValue={undefined}
        render={({ field: { onChange, value } }) => (
          <Select
            options={options}
            name={name}
            value={options.find(
              ({ value: optionValue }) => optionValue === value
            )}
            onChange={(val) => onChange(val?.value)}
            defaultValue={defaultValue || undefined}
            isDisabled={isDisabled}
            menuPortalTarget={document.body}
            styles={{
              control: (baseStyles) => ({
                ...baseStyles,
                borderRadius: "8px",
              }),
              input: (baseStyles) => ({
                ...baseStyles,
                color: "#718096",
                height: "40px",
                paddingTop: "0px",
                paddingBottom: "0px",
                margin: 0,
              }),
              singleValue: (baseStyles) => ({
                ...baseStyles,
                color: "#718096",
              }),
              valueContainer: (baseStyles) => ({
                ...baseStyles,
                color: "#718096",
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: "16px",
                paddingRight: "16px",
              }),
              menuPortal: (baseStyles) => ({
                ...baseStyles,
                zIndex: 9999,
              }),
            }}
          />
        )}
      />
      {error && <p className="text-red-500 text-sm mt-1">{error.message}</p>}
    </>
  );
}
